import { render, staticRenderFns } from "./EditChoiceColor.vue?vue&type=template&id=0eadba4c&scoped=true"
import script from "./EditChoiceColor.vue?vue&type=script&lang=js"
export * from "./EditChoiceColor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0eadba4c",
  null
  
)

export default component.exports